import script from "./RejectsStopDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./RejectsStopDetail.vue?vue&type=script&setup=true&lang=js"

import "./RejectsStopDetail.vue?vue&type=style&index=0&id=3a7be4a0&lang=scss"

const __exports__ = script;

export default __exports__